import axiosInstance from 'api/axiosInstance'

export const getNotifications = async (
  currentPage: number = 1,
  filter: string,
  signal?: AbortSignal
) => {
  const { data } = await axiosInstance({
    method: 'GET',
    url: '/api/user/notification',
    params: { type: filter, page: currentPage },
    signal,               // ← important
  })

  return {
    nextCursor: currentPage < data.meta.last_page ? currentPage + 1 : undefined,
    prevCursor: currentPage > 1 ? currentPage - 1 : undefined,
    page: { data }
  }
}

export const getUserActivity = async (
    currentPage: number = 1,
    filter: {
        type?: string
        userId: string
    }
) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: `/api/user/notification?type=${filter.type ?? 'all'}&user_id=${
            filter.userId
        }&page=${currentPage}` // todo: set the correct url/path
    })
    return {
        nextCursor:
            currentPage < data.meta.last_page ? currentPage + 1 : undefined,
        prevCursor: currentPage > 1 ? currentPage - 1 : undefined,
        page: {
            data
        }
    }
}

export const apiNotificationsAsRead = async () => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: '/api/user/notification/unread-as-read'
    })

    return data
}

export const apiNotificationAsRead = async (notificationId: number) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: `/api/user/notification/${notificationId}`
    })

    return data
}
